/*====================================
    重設企業用戶密碼的 modal

    Author : Gray
    最後更新時間 : 2017 / 05 / 25
====================================*/

window.InifECMobileApp.directive('resetBusinessPwModal', ['$rootScope', '$ngModal', '$timeout', '$state', 'BusinessMemberService',
    function($rootScope, $ngModal, $timeout, $state, BusinessMemberService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            //----------------------------
            // [private] 開啟modal
            //----------------------------
            var openModal = function() {

                $ngModal.openModal('reset-business-pw-modal');
            }

            //----------------------------
            // [private] 關閉modal
            //----------------------------
            var closeModal = function() {

                $ngModal.closeModal('reset-business-pw-modal');
            }

            //----------------------------
            // 取消重設密碼
            //----------------------------
            var cancelReset = function() {

                $state.go(window.STATES.HOME);
                closeModal();
            }

            var resetPwByEmail = function() {
                if ($scope.isUpdating) {
                    return;
                }
                $scope.isError = false;
                $scope.isResetSuccess = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
                $scope.isCheckError = false;
                $scope.errorMsg = "";

                if ($scope.email == "" || $scope.token == "") {
                    $scope.isError = true;
                    $scope.errorMsg = '系統忙碌中，請稍後再試';
                    return;
                }

                if (!$scope.form.pwd) {
                    $scope.isPwdEmpty = true;
                }

                if (!$scope.form.repwd) {
                    $scope.isRePwdEmpty = true;
                }

                if($scope.form.pwd && $scope.form.repwd &&
                   $scope.form.pwd != $scope.form.repwd) {
                    $scope.isCheckError = true;
                    $scope.errorMsg = '兩次的密碼輸入的不一致';
                }

                if($scope.isPwdEmpty || $scope.isRePwdEmpty || $scope.isCheckError) {
                    return;
                }

                $scope.isUpdating = true;

                BusinessMemberService.updatePassword($scope.token, $scope.form.pwd, $scope.email).then(function(result) {
                    if(result) {
                        $scope.isUpdating = false;
                        $scope.isResetSuccess = true;
                        cancelReset();

                        $rootScope.$broadcast("OPEN_SUCCESS_MESSAGE_MODAL", {
                            title: '密碼重設成功',
                            desc: '您的密碼已重設，往後請使用新密碼登入！'
                        });
                    }
                }, function(error) {
                    $scope.isError = true;
                    $scope.isUpdating = false;
                    $scope.errorMsg = error.message || '系統忙碌中，請稍後再試';
                });
            }

            var resetFormdata = function() {

                $scope.form.pwd = '';
                $scope.form.repwd = '';

                $scope.errorMsg = "";

                $scope.isError = false;
                $scope.isResetSuccess = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
                $scope.isCheckError = false;
                $scope.isUpdating = false;

                $scope.isoldPwdEmpty = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_RESET_BUSINESS_PW_MODAL", function(e, data) {
                resetFormdata();
                $scope.email = data.email;
                $scope.token = data.token;
                
                openModal();
            });

            /*==========================
                Members
            ==========================*/

            $scope.email = "";
            $scope.token = "";
            $scope.errorMsg = "";

            $scope.isError = false;
            $scope.isResetSuccess = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;
            $scope.isCheckError = false;
            $scope.isUpdating = false;

            $scope.isoldPwdEmpty = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;

            $scope.form = {
                pwd: '',
                repwd: '',
            };

            /*==========================
                Methods
            ==========================*/
            $scope.cancelReset = cancelReset;
            $scope.resetPwByEmail = resetPwByEmail;

            /*==========================
                init
            ==========================*/
        }];

        _dir.controller = controller;
        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/reset_business_pw.html";

        return _dir;

    }
]);
